<script lang="ts">
import type { Notification } from '@/types'
import { type PropType, defineComponent } from 'vue'

/**
 * A modal shown when a member levels up.
 */
export default defineComponent({
  props: {
    /**
     * A notification object containing the leveled up data.
     */
    notification: {
      type: Object as PropType<Notification>,
      required: true,
    },
  },
  emits: ['closeNotification'],
  methods: {
    /**
     * Closes the notification modal.
     */
    closeNotification(route?: string) {
      if (route) {
        void this.$router.push({ name: route })
      }
      this.$emit('closeNotification')
    },
  },
})
</script>

<template>
  <div
    class="relative flex w-full flex-col gap-x-6 rounded-md bg-black px-4 py-8 text-pure-white md:flex-row md:p-8"
  >
    <img
      src="@/assets/images/members-zone/rocket.png"
      class="z-0 hidden self-end md:block"
      role="presentation"
    />

    <div class="flex flex-col gap-6">
      <div class="relative z-0 flex flex-col">
        <h1 class="heading-2 z-10">
          {{ notification.headline }}
        </h1>

        <p class="z-10 max-sm:w-2/3">
          {{ notification.content_1 }}
          {{ notification.content_2 }}
        </p>

        <img
          src="@/assets/images/members-zone/rocket-sm.png"
          class="absolute -bottom-7 right-0 block md:hidden"
          role="presentation"
        />
      </div>

      <div class="relative z-10 mt-auto">
        <AppButton
          v-for="(button, index) in notification.buttons.actions"
          :key="index"
          class="button-primary w-full text-center font-bold"
          :title="button.text"
          :icon="null"
          @click="closeNotification(button.route)"
        >
          {{ button.text }}
        </AppButton>

        <button
          type="button"
          class="mt-2 w-full py-3 text-center text-sm font-bold"
          @click="closeNotification()"
        >
          Dismiss
        </button>
      </div>
    </div>
  </div>
</template>
